import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert } from 'react-bootstrap';

import { useRecoilValue } from 'recoil';
import { selectedUserState } from '../../states/selectedUserState';
import UserPermissions from '../../services/user.permissions.service';

import MainBlockContainer from '../MainBlockContainer';
import MainBlockHeader from '../MainBlockHeader';
import Loading from '../../components/Shared/Loading';
import TrendCharts from '../../components/Shared/Trends/TrendCharts';

import api from '../../services/api';

export default function Trends() {
  const { userUid } = useParams();
  const { t } = useTranslation();
  const user = useRecoilValue(selectedUserState);
  const permissions = new UserPermissions(user);
  const canExclude = permissions.hasRecordsEditPermission();
  const [loading, setLoading] = useState(true);
  const [trendData, setTrendData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(`/user/${userUid}/trends`)
      .then((response) => {
        setTrendData(response.data);
        setLoading(false);
      })
      .catch(() => {
        setError(t('messages.loadError'));
        setLoading(false);
      });
  }, [userUid]);

  return (
    <>
      <MainBlockHeader header={t('trends.header')} />
      <MainBlockContainer>
        {loading && <Loading />}
        {error && <Alert variant="danger">{error}</Alert>}
        {!loading && !error && (
          <TrendCharts
            data={trendData}
            userUid={canExclude ? userUid : undefined}
            setTrendData={canExclude ? setTrendData : undefined}
          />
        )}
      </MainBlockContainer>
    </>
  );
}
